import { render } from "./vyingbipresentadd.vue?vue&type=template&id=92eb260c&scoped=true"
import script from "./vyingbipresentadd.vue?vue&type=script&lang=js"
export * from "./vyingbipresentadd.vue?vue&type=script&lang=js"

import "./vyingbipresentadd.vue?vue&type=style&index=0&id=92eb260c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92eb260c"]])

export default __exports__